export default class Verification {

    static STATUS_PENDING = 0;
    static STATUS_APPROVED = 1;
    static STATUS_DECLINED = 2;

    id = 0;
    status = Verification.TYPE_PENDING;
    token = null;
    info = {};
    country = null;
    can_start_kyc = null;

    constructor(data) {
        this.id = data.id;
        this.status = data.status;
        this.token = data.token
        this.info = data.info;
        this.country = data.country;
        this.can_start_kyc = data.can_start_kyc;
    }

    get isApproved() {
        return this.status == Verification.STATUS_APPROVED;
    }

    get isPending() {
        return this.status == Verification.STATUS_PENDING;
    }

    get isDeclined() {
        return this.status == Verification.STATUS_DECLINED;
    }
}